import type { FileRecordVersion } from "@cohesive/api-client";
import { createContext, useContext } from "react";

/**
 * When defined, the subtree is the version-history dialog preview pane and
 * `useFileRecordVersionPreview` resolves URLs for `value` (or live when null).
 * When undefined, the main file pane always shows the live file.
 */
export const FileRecordVersionPreviewPaneContext = createContext<
  FileRecordVersion | null | undefined
>(undefined);

export function useFileRecordVersionPreviewPaneContext() {
  return useContext(FileRecordVersionPreviewPaneContext);
}
